import { render } from "./workflowcard-item.vue?vue&type=template&id=698f0a32"
import script from "./workflowcard-item.vue?vue&type=script&lang=js"
export * from "./workflowcard-item.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__